module.exports = __webpack_public_path__ + "img/status-ended.87eb1558.svg";